export const Loop = (props) => {
  const { size = 28, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
        <path
          d='M8.33325 7.54683C7.57825 6.51516 6.37658 5.8335 4.99992 5.8335V5.8335C2.69909 5.8335 0.833252 7.69933 0.833252 10.0002V10.0002C0.833252 12.301 2.69909 14.1668 4.99992 14.1668V14.1668V14.1668C6.55075 14.1668 7.98825 13.3527 8.78575 12.0235L9.99992 10.0002L11.2141 7.97683C12.0116 6.64766 13.4491 5.8335 14.9999 5.8335V5.8335V5.8335C17.3008 5.8335 19.1666 7.69933 19.1666 10.0002V10.0002C19.1666 12.301 17.3008 14.1668 14.9999 14.1668V14.1668C13.6233 14.1668 12.4216 13.4852 11.6666 12.4535'
          stroke='currentcolor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.27481 5.02344L8.70898 7.4851L6.24731 7.91927'
          stroke='currentcolor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
